'use client';

import React from 'react';
import { Currency } from 'utils/Currency';

const params = ['currency'];

export const useForwardProductParams = ({
  defaultCurrency,
}: {
  defaultCurrency?: Currency;
}): ((url: string) => string) => {
  const [currentLocationSearch, setCurrentLocationSearch] = React.useState('');

  React.useEffect(() => {
    setCurrentLocationSearch(document.location.search);
  }, []);

  return (url: string) => {
    const newUrl = new URL(url);

    const linkSearchParams = new URLSearchParams(newUrl.search);
    const documentSearchParams = new URLSearchParams(currentLocationSearch);

    params.forEach((param) => {
      const value = documentSearchParams.get(param);
      if (value) linkSearchParams.set(param, value);
    });

    if (!linkSearchParams.get('currency')) {
      linkSearchParams.set('currency', defaultCurrency ?? Currency.inr);
    }

    newUrl.search = linkSearchParams.toString();

    return newUrl.href;
  };
};
